import { render, staticRenderFns } from "./DetailsMaizeSowing.vue?vue&type=template&id=b7c70988&scoped=true&"
import script from "./DetailsMaizeSowing.vue?vue&type=script&lang=js&"
export * from "./DetailsMaizeSowing.vue?vue&type=script&lang=js&"
import style0 from "./DetailsMaizeSowing.vue?vue&type=style&index=0&id=b7c70988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c70988",
  null
  
)

export default component.exports